"use client";

import { useEffect, useSyncExternalStore } from "react";

type Paths = Record<string, string>;

type Listener = () => void;

let paths: Paths = {};

const listeners = new Set<Listener>();

/** Where the page on screen lives in each language when its address differs by language (a post or page has its own address per language): set by the page, read by the language switcher. */
const alternatePathsStore = {
  get: (): Paths => paths,
  set(next: Paths) {
    paths = next;
    listeners.forEach((l) => l());
  },
  subscribe(listener: Listener) {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
  },
};

/** Tells the language switcher where this page lives in each language (addresses without the language prefix). Shows nothing. */
export function SetAlternatePaths({ paths }: { paths: Record<string, string> }) {
  const key = JSON.stringify(paths);
  useEffect(() => {
    alternatePathsStore.set(JSON.parse(key) as Record<string, string>);
    return () => alternatePathsStore.set({});
  }, [key]);
  return null;
}

const none = {};

/** The address of the page on screen in each language, when it has its own per language (empty otherwise). */
export function useAlternatePaths(): Record<string, string> {
  return useSyncExternalStore(alternatePathsStore.subscribe, alternatePathsStore.get, () => none);
}
